<p-dialog
  modal
  [(visible)]="isOpen"
  [style]="{ width: 'calc(100% - 4rem)', height: '100%' }"
  (onHide)="closeModal()"
>
  <div class="modal-header">
    <h2 class="modal-title">New Remote Source</h2>
  </div>
  <div class="modal-body">
    <!-- Form fields for creating a new remote source -->
    <div class="form-field">
      <label for="name">Name:</label>
      <input id="name" pInputText [(ngModel)]="newRemoteSource.name" />
    </div>
    <div class="form-field">
      <label for="plugin">Plugin:</label>
      <input id="plugin" pInputText [(ngModel)]="newRemoteSource.plugin" />
    </div>
    <div class="form-field">
      <label for="remoteAddress">Remote Address:</label>
      <input
        id="remoteAddress"
        pInputText
        [(ngModel)]="newRemoteSource.remoteAddress"
      />
    </div>
  </div>
  <div class="modal-footer">
    <p-button label="Cancel" (click)="closeModal()"></p-button>
    <p-button
      label="Create"
      severity="primary"
      [disabled]="
        !newRemoteSource.name ||
        !newRemoteSource.plugin ||
        !newRemoteSource.remoteAddress
      "
      [loading]="isLoading"
      (click)="createRemoteSource()"
    ></p-button>
  </div>
</p-dialog>

<div class="remote-sources-container">
  <div class="remote-sources-table">
    <div class="remote-sources-header">
      <input
        pInputText
        placeholder="Filter by name"
        class="remote-sources-filter w-full"
        [(ngModel)]="filterText"
      />
      <p-button
        label="New Remote source"
        severity="primary"
        raised
        (click)="openModal()"
      ></p-button>
    </div>

    <p-table
      [value]="remoteSourcesList"
      [showCurrentPageReport]="false"
      responsiveLayout="scroll"
    >
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width: 28rem" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>Plugin</th>
          <th>Remote Address</th>
          <th>Is Synced</th>
          <th>Last sync</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-remoteSource>
        <tr>
          <td>{{ remoteSource?.name }}</td>
          <td>{{ remoteSource?.plugin }}</td>
          <td>{{ remoteSource?.remoteAddress }}</td>
          <td>{{ remoteSource?.isSynced ? "Yes" : "No" }}</td>
          <td>
            {{
              remoteSource?.lastSync
                ? (remoteSource.lastSync | date: "short")
                : ""
            }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
